<div class="agpr-formField agpr-headerDisplaySettingsField" role="group" [attr.aria-labelledby]="id + 'chartHeader_label'">
    <h3 *ngIf="field?.label" [id]="id + '_chartHeader_label'" class="agpr-headerDisplaySettingsField-header">{{ field.label | localize }}</h3>
    @if (displayEntityProfile) {
        <agpr-checkbox
            [id]="'chartHeader_displayEntityProfile'"
            [binary]="true"
            [label]="'Reports.chartSetupDialog.displaySettings.' + displayEntityProfile"
            [(ngModel)]="entityProfile"
            (ngModelChange)="updateValue()"
        ></agpr-checkbox>
    }
    <agpr-checkbox
        [id]="'chartHeader_displayTitle'"
        [binary]="true"
        label="Reports.chartSetupDialog.displaySettings.title"
        [(ngModel)]="title"
        (ngModelChange)="updateValue()"
    ></agpr-checkbox>
    @if (displayDate) {
        <agpr-checkbox
            [id]="'chartHeader_displayDate'"
            [binary]="true"
            label="Reports.chartSetupDialog.displaySettings.date"
            [(ngModel)]="date"
            (ngModelChange)="updateValue()"
        ></agpr-checkbox>
    }
    @if (displaySource) {
        <agpr-checkbox
            [id]="'chartHeader_displaySource'"
            [binary]="true"
            [label]="displaySourceAsLink ? 'Reports.chartSetupDialog.displaySettings.source' : 'Reports.chartSetupDialog.displaySettings.sourceLabel'"
            [(ngModel)]="source"
            (ngModelChange)="updateValue()"
        ></agpr-checkbox>
    }
    @if (displayPreviousPeriod) {
        <agpr-checkbox
            [id]="'chartHeader_displayPreviousPeriod'"
            [binary]="true"
            label="Reports.chartSetupDialog.displaySettings.previousPeriod"
            [disabled]="disablePreviousPeriod"
            [agprTooltip]="disablePreviousPeriod ? 'Reports.chartSetupDialog.displaySettings.previousPeriod.disabledTooltip' : ''"
            tooltipPosition="top"
            [(ngModel)]="previousPeriod"
            (ngModelChange)="updateValue()"
        ></agpr-checkbox>
    }
    @if (previousPeriod) {
        <div class="agpr-headerDisplaySettingsField-displayTrendIndicators">
            <agpr-checkbox
                [id]="'chartHeader_displayTrendIndicators'"
                [binary]="true"
                label="Reports.chartSetupDialog.displaySettings.trendIndicators"
                [(ngModel)]="trendIndicators"
                (ngModelChange)="updateValue()"
            ></agpr-checkbox>
        </div>
    }
</div>
